// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/inventory-manufacturers/archive',
        component: () =>
            import('@/pages/[organisation]/inventory/inventory-manufacturers/archive.vue'),
        name: 'inventory.inventory-manufacturers.archived-inventory-manufacturers',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.inventory-manufacturers.update-inventory-manufacturer',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-manufacturers/archive/[id].vue'),
                name: 'inventory.inventory-manufacturers.view-archived-inventory-manufacturer',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-manufacturers.update-inventory-manufacturer',
                },
            },
        ],
    },

    {
        path: '/:organisation/inventory/inventory-manufacturers',
        component: () =>
            import('@/pages/[organisation]/inventory/inventory-manufacturers.vue'),
        name: 'inventory.inventory-manufacturers.search-inventory-manufacturers',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.inventory-manufacturers.view-inventory-manufacturers',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-manufacturers/new.vue'),
                name: 'inventory.inventory-manufacturers.create-inventory-manufacturer',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-manufacturers.create-inventory-manufacturer',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-manufacturers/[id].vue'),
                name: 'inventory.inventory-manufacturers.view-inventory-manufacturer',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-manufacturers.view-inventory-manufacturers',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/inventory-manufacturers/[id]/edit.vue'),
                name: 'inventory.inventory-manufacturers.update-inventory-manufacturer',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.inventory-manufacturers.update-inventory-manufacturer',
                },
            },
        ],
    },
];
